module.exports = __webpack_public_path__ + "img/3-1-4.4f85c2ee.svg";